import { Component, OnInit, AfterViewChecked, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database-deprecated';
import { NotificationService } from '../_services/notification.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../_services/user.service';
import { Subscription, BehaviorSubject, Observable } from 'rxjs';
import { Http } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit, AfterViewChecked, AfterViewInit {

  userMessageKey: string;
  sender: any = {};
  messages = new BehaviorSubject<any>([]);
  chats: any[] = [];
  filterChats: any[] = [];
  userId = this.userService.getUid();
  recipient: any;
  messagePage = false;
  messageText: any = '';
  isChatsOrMessages = true;
  private subscription: Subscription = new Subscription();
  constructor(private afm: AngularFireDatabase,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private http: Http,
    private userSerw: UserService,
    private afs: AngularFirestore,
    private notificationService: NotificationService,
    private modalService: NgbModal,
    private userService: UserService) {
  }

  ngAfterViewInit() {
  }

  handleSelection(a) {
    this.messageText += a;
  }

  ngAfterViewChecked() {
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  escapeTurkishChars(returnString) {
    return returnString
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'c')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'u')
      .replace(/,/g, '')
      .replace(/\./g, '')
      .replace(/\'/g, '')
      .replace(/\-/g, '')
      .replace(/\//g, '');
  }

  filterUsers(username) {

    this.filterChats = this.chats.filter(
      item => {
        return this.escapeTurkishChars(item.user.firstname).toLowerCase().indexOf(username) > -1 ||
          this.escapeTurkishChars(item.user.lastname).toLowerCase().indexOf(username) > -1
      });
  }
  backToChatsInMobile() {
    this.isChatsOrMessages = !this.isChatsOrMessages;
  }

  openChatWindow(key) {


    this.isChatsOrMessages = !this.isChatsOrMessages;
    this.userMessageKey = key;
    if (this.userId) {
      let startAt;
      try {

        this.afs.collection('users').doc(this.userId).collection('deletedMessages').doc(this.userMessageKey).ref.get().then((data => {
          if (data.exists) {

            startAt = data.data().deletedDate;

          }
        })).then(() => {
          if (startAt) {

            this.subscription.add(this.afs.collection('messages').doc(this.userMessageKey)
              .collection('message', ref => ref.orderBy('modifyDate').startAt(startAt))
              .valueChanges().subscribe(data => {
                this.messages.next(data);
              }))

          }
          else {
            this.subscription.add(this.afs.collection('messages').doc(this.userMessageKey)
              .collection('message', ref => ref.orderBy('modifyDate'))
              .valueChanges().subscribe(data => {
                this.messages.next(data);
              }))

          }
        })
        // startAt = this.sender.deletedMessages[key].deletedDate;
      } catch (e) { }




      try {
        this.messagePage = true;
        this.afs.collection('users').doc(this.sender.id).collection('myChats').doc(key).ref.get().then(user => {
          if (user.exists) {
            this.recipient = user.data().user;

          }
          else {

            this.recipient = {}

            this.cd.markForCheck();
          }
        }).then(() => {
          if (this.recipient.userKey) {
            this.afs.collection('users').doc(this.userId).collection('messagesNotifications').doc(this.recipient.userKey).delete();
            this.afs.collection('users').doc(this.userId).collection('myChats').doc(key).update({ isSeen: false })
          }
        })
      } catch (e) { }
    }
  }

  open(content, key) {

    this.modalService.open(content);
    this.userMessageKey = key;

  }

  deleteChat() {
    this.afs.collection('users').doc(this.userId).collection('myChats').doc(this.userMessageKey).delete().then(() => {

    }).then(() => {
      this.afs.collection('users').doc(this.userId).collection('deletedMessages')
        .doc(this.userMessageKey).set({
          messageKey: this.userMessageKey,
          deletedDate: Date.now()
        })

    }).then(() => {
      this.afs.collection('users').doc(this.userId).collection('myChats').ref.get().then((data => {
        if (!data.empty) {
          let arrayChat = [];
          data.docs.map(a => {
            arrayChat.push(a.data());
          })



          this.chats = arrayChat.sort(function (a, b) {
            a = a.modifyDate;
            b = b.modifyDate;
            return a > b ? -1 : a < b ? 1 : 0;
          });

        }
        else {
          this.chats = [];
        }
      }))




      if (this.chats.length) {

        this.recipient = this.chats[0].user;
        this.openChatWindow(this.chats[0].id);
      } else {
        this.recipient = {};
      }

    })

    this.cd.markForCheck();


  }

  getIpAdress(): Observable<any> {
    return this.http.get("https://api.bigadvice.com/helper/ip")
      .map(data => data.json());
  }

  createMessages(text) {
    if (text.replace(/\s/g, '') == '') {
      return;
    }
    this.afm.list('.info/serverTimeOffset').$ref.once('value', offSet => {
      this.subscription.add(this.getIpAdress().subscribe(ip => {
        this.afs.collection('messages').doc(this.userMessageKey).collection('message').add({
          user: {
            firstname: this.sender.firstname,
            lastname: this.sender.lastname,
            email: this.sender.email,
            username: this.sender.username,
            profileImage: this.sender.profileImage
          },
          ipAdress: ip,
          message: text,
          modifyDate: Date.now() + offSet.val()

        }).then(() => {
          this.userSerw.userLog('send-message', ip);
        })
      }));
      this.afs.collection('users').doc(this.userId).collection('myChats').doc(this.userMessageKey).update({
        lastMessage: text,
        modifyDate: Date.now() + offSet.val()
      })
      this.afs.collection('users').doc(this.recipient.userKey).collection('myChats').doc(this.userMessageKey).set({
        lastMessage: text,
        isSeen: true,
        modifyDate: Date.now() + offSet.val(),
        id: this.userMessageKey,
        user: {
          firstname: this.sender.firstname,
          lastname: this.sender.lastname,
          username: this.sender.username,
          profileImage: this.sender.profileImage,
          userKey: this.sender.id
        }
      })

      const notification = {
        user: {
          firstname: this.sender.firstname,
          lastname: this.sender.lastname,
          email: this.sender.email,
          username: this.sender.username,
          profileImage: this.sender.profileImage
        },
        id: this.userId,
        chatKey: this.userMessageKey,
        title: 'Mesaj',
        description: text,
        modifyDate: Date.now() + offSet.val(),
        isUnseen: true
      };
      this.notificationService.pushMessagesNotification(notification, this.recipient.userKey, this.userId);
      this.afs.collection('users').doc(this.userId).collection('myChats').doc(this.userMessageKey).update({
        isSeen: false
      })
      this.messageText = '';

    });
  }

  ngOnInit() {

    this.subscription.add(this.userService.getUser().subscribe((snap: any) => {
      this.sender = snap;
      if (snap.id) {

        this.afs.collection('users').doc(snap.id).collection('myChats').ref.get().then((data => {


          if (!data.empty) {
            let arrayChat = [];
            data.docs.map(a => {
              arrayChat.push(a.data());
            })




            this.chats = arrayChat.sort(function (a, b) {
              a = a.modifyDate;
              b = b.modifyDate;
              return a > b ? -1 : a < b ? 1 : 0;
            });


          }
        })).then(() => {
          const messageKey = this.route.snapshot.queryParams['message'];
          if (messageKey) {

            this.openChatWindow(messageKey);
          }

        })
      }

      // if (snap.myChats) {
      //   Object.keys(snap.myChats).forEach(data => {
      //     snap.myChats[data].$key = data;
      //   });
      //   this.chats = Object.values(snap.myChats).sort(function (a, b) {
      //     a = a.modifyDate;
      //     b = b.modifyDate;
      //     return a > b ? -1 : a < b ? 1 : 0;
      //   });
      // }
    }))

  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/messages/messages.component.ts